
























import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { IMenuItem, IComputedSubMenuData } from "../..";
import SecondLevelMenuItem from './_SecondLevelMenuItem.vue';

@Component({
    components: {
        SecondLevelMenuItem,
    },
})
export default class SecondLevelMenuPanel extends Vue {
    @Prop({ default: () => [] }) public panelData: [IComputedSubMenuData[], IComputedSubMenuData[]];
    @Prop({ required: true }) public itemIndex: number;

    @Emit('navigate') public navigate(e: Event) { return e; }
}
